// This function adds styles for Excalidraw to improve loading experience
export const preloadExcalidrawAssets = () => {
  if (typeof window === 'undefined') return;
  
  // Only run once
  if ((window as any).__EXCALIDRAW_PRELOADED__) return;
  (window as any).__EXCALIDRAW_PRELOADED__ = true;

  // Create a style element to hide loading states
  const style = document.createElement('style');
  style.textContent = `
    .excalidraw .LoadingMessage,
    .excalidraw .LoadingMessage *,
    .excalidraw .LoadingMessage:after,
    .excalidraw .LoadingMessage:before,
    .excalidraw .LoadingMessage *:after,
    .excalidraw .LoadingMessage *:before {
      display: none !important;
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }
    
    .excalidraw .App-menu_top {
      transition: none !important;
      opacity: 1 !important;
    }
    
    .excalidraw {
      --transition: none !important;
      --transition-lg: none !important;
      --transition-md: none !important;
      --transition-sm: none !important;
    }
  `;
  document.head.appendChild(style);
};

// Run when this module is imported
preloadExcalidrawAssets();
